import {combineReducers} from "redux";
import mainReducer from "./store/reducer";

const rootReducer = combineReducers({main: mainReducer});

export default rootReducer
